import { render, staticRenderFns } from "./Lavado.vue?vue&type=template&id=a9718e02&scoped=true"
import script from "./Lavado.vue?vue&type=script&lang=js"
export * from "./Lavado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9718e02",
  null
  
)

export default component.exports